import Immutable from 'immutable';

import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  CLEAR_IDLING_CONSUMPTION_MOTIVES,
  CLEAR_IDLING_CONSUMPTION_OBSERVATION,
  CLEAR_IDLING_CONSUMPTION_OBSERVATIONS,
  FLAG_GETTING_IDLING_CONSUMPTION_MOTIVES,
  FLAG_GETTING_IDLING_CONSUMPTION_OBSERVATIONS,
  FLAG_IDLING_CONSUMPTION_OBSERVATION_ACTIVITY,
  GET_IDLING_CONSUMPTION_MOTIVES,
  GET_IDLING_CONSUMPTION_OBSERVATION,
  GET_IDLING_CONSUMPTION_OBSERVATIONS,
} from '../../../actions/types';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
  motives: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_IDLING_CONSUMPTION_OBSERVATIONS:
      return state.setIn(['all', 'loading'], payload);
    case GET_IDLING_CONSUMPTION_OBSERVATIONS:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_IDLING_CONSUMPTION_OBSERVATIONS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['motives', 'content']),
      );
    case FLAG_IDLING_CONSUMPTION_OBSERVATION_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_IDLING_CONSUMPTION_OBSERVATION:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_IDLING_CONSUMPTION_OBSERVATION:
      return state.setIn(
        ['current', 'content'],
        INITIAL_STATE.getIn(['current', 'content']),
      );
    case FLAG_GETTING_IDLING_CONSUMPTION_MOTIVES:
      return state.setIn(['motives', 'loading'], payload);
    case GET_IDLING_CONSUMPTION_MOTIVES:
      return state.setIn(['motives', 'content'], Immutable.Map(payload));
    case CLEAR_IDLING_CONSUMPTION_MOTIVES:
      return state.setIn(
        ['motives', 'content'],
        INITIAL_STATE.getIn(['motives', 'content']),
      );
    default:
      return state;
  }
};
